import { API_NOTIFICATION } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function minusBadges() {
  return {
    type: ACTION_TYPES.ALERT_MINUS,
  };
}

export function readNotification(id) {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_READ_REQUESTED,
      ACTION_TYPES.NOTIFICATION_READ_SUCCESS,
      ACTION_TYPES.NOTIFICATION_READ_FAILED,
    ],
    promise: client => client.post(`/notifications/${id}/read`),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

export function readAllNotifications() {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_READ_ALL_REQUESTED,
      ACTION_TYPES.NOTIFICATION_READ_ALL_SUCCESS,
      ACTION_TYPES.NOTIFICATION_READ_ALL_FAILED,
    ],
    promise: client => client.post('/notifications/read'),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

export function seenAllNotifications() {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_SEEN_ALL_REQUESTED,
      ACTION_TYPES.NOTIFICATION_SEEN_ALL_SUCCESS,
      ACTION_TYPES.NOTIFICATION_SEEN_ALL_FAILED,
    ],
    promise: client => client.post('/notifications/seen'),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

export function getBadges() {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_GET_BADGES_REQUESTED,
      ACTION_TYPES.NOTIFICATION_GET_BADGES_SUCCESS,
      ACTION_TYPES.NOTIFICATION_GET_BADGES_FAILED,
    ],
    promise: client => client.get('/profile', {}),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

export function getNotifications(params) {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_GET_LIST_REQUESTED,
      ACTION_TYPES.NOTIFICATION_GET_LIST_SUCCESS,
      ACTION_TYPES.NOTIFICATION_GET_LIST_FAILED,
    ],
    promise: client => client.get('/notifications', { params }),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

export function registerDevice(body) {
  return {
    types: [
      ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_REQUESTED,
      ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_SUCCESS,
      ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_FAILED,
    ],
    promise: client => client.post('/devices', body),
    options: {
      clientName: API_NOTIFICATION,
    },
  };
}

// export function alertUnregisterDevice(body) {
//   return {
//     types: [
//       ACTION_TYPES.ALERT_DEVICE_UNREGISTER_REQUESTED,
//       ACTION_TYPES.ALERT_DEVICE_UNREGISTER_SUCCESS,
//       ACTION_TYPES.ALERT_DEVICE_UNREGISTER_FAILED,
//     ],
//     promise: client => client.post('/devices/unregister', body),
//     options: {
//       clientName: API_ALERT,
//     },
//   };
// }
